module.exports = __webpack_public_path__ + "media/images/member_mypage_logo-5830f4721ae1cb04b9ca2526791a3903.png";